import React from "react";

const AppointmentPage = () => {
  return (
    <div style={{ textAlign: "center", padding: "20px" }}>
      <h1>Make an Appointment</h1>
      <p>Feature coming soon!</p>
    </div>
  );
};

export default AppointmentPage;
